export const EMPTY_EMPRESA = {
  nome: "", slug: "", cnpj: "", inscricao_estadual: "", cep: "", endereco: "", telefone: "", whatsapp1: "", whatsapp2: "",
  whatsapp_msg_template: "", email: "", segmento: "", tagline: "", cor_primaria: "#EA580C", logo_base64: "",
  require_foto_evidencia: true, require_codigo_4dig: true, require_gps_capture: true, rastreamento_gps_liberado: true,
  licenca_ativa: true, licenca_expira_em: "", licenca_observacao: "",
  backup_horario_1: "", backup_horario_2: "", backup_horario_3: "", regiao_raio_centro_km: "",
};
export const DEFAULT_WPP_TEMPLATE = "Olá {cliente}! Sua entrega saiu para entrega às {hora}. Pedido {pedido}. Obrigado pela preferência! 🛵";

export const formatCep = (s) => (s || "").replace(/\D/g, "").slice(0, 8).replace(/^(\d{5})(\d)/, "$1-$2");

// Número internacional do WhatsApp de suporte: aceita "+5511999999999", "5511999999999" ou "(11) 99999-9999".
export const cleanPhone = (s) => (s || "").replace(/[^\d+]/g, "").slice(0, 16);

export const formatCnpj = (s) => {
  const d = (s || "").replace(/\D/g, "").slice(0, 14);
  return d
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1/$2")
    .replace(/(\d{4})(\d)/, "$1-$2");
};

export const cnpjDigits = (s) => (s || "").replace(/\D/g, "");

export function isValidCnpj(cnpj) {
  const d = cnpjDigits(cnpj);
  if (d.length !== 14) return false;
  if (/^(\d)\1{13}$/.test(d)) return false; // todos iguais
  const calc = (base, weights) => {
    let sum = 0;
    for (let i = 0; i < weights.length; i++) sum += parseInt(base[i], 10) * weights[i];
    const mod = sum % 11;
    return mod < 2 ? 0 : 11 - mod;
  };
  const w1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const w2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  return calc(d.slice(0, 12), w1) === parseInt(d[12], 10) && calc(d.slice(0, 13), w2) === parseInt(d[13], 10);
}

export async function lookupCep(cep) {
  const digits = (cep || "").replace(/\D/g, "");
  if (digits.length !== 8) return null;
  try {
    const r = await fetch(`https://viacep.com.br/ws/${digits}/json/`);
    const d = await r.json();
    return d.erro ? null : d;
  } catch (e) { console.debug("ViaCEP indisponível", e); return null; }
}

export async function lookupCnpj(cnpj) {
  const digits = cnpjDigits(cnpj);
  if (digits.length !== 14) return null;
  try {
    const r = await fetch(`https://brasilapi.com.br/api/cnpj/v1/${digits}`);
    return r.ok ? await r.json() : null;
  } catch (e) { console.debug("BrasilAPI indisponível", e); return null; }
}
